import React, { InputHTMLAttributes } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IoIosArrowDown } from "react-icons/io";

interface InputTextProps {
  label: string;
  name: string;
  defaultValue?: string;
  control: Control<FieldValues>;
  required?: boolean;
  requiredMessage?: string;
  placeholder?: string;
  rules?: Object;
  inputProps?: InputHTMLAttributes<HTMLSelectElement>;
  options: { value: string; label: string }[];
  disabled?: boolean;
  shouldUnregister?: boolean;
  disabledPlaceholder?: string;
  onChange?: () => void;
}

function SelectField({
  label,
  name,
  control,
  required,
  requiredMessage,
  rules = {},
  defaultValue = "",
  inputProps = {},
  placeholder,
  disabled = false,
  shouldUnregister,
  disabledPlaceholder,
  onChange = () => {},
  options = [],
}: InputTextProps) {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      rules={{
        required: requiredMessage || (required && "Please select an option"),
        ...rules,
      }}
      control={control}
      shouldUnregister={shouldUnregister}
      disabled={disabled}
      render={({ field, fieldState: { error } }) => (
        <div className="relative">
          <label className="text-base ml-1 mb-0.5 block" htmlFor={field?.name}>
            <span>
              {t(label)}
              {(required || requiredMessage) && (
                <span className="text-red-600 ml-0.5 text-base">*</span>
              )}
            </span>
          </label>
          <div className="relative">
            <select
              id={field.name}
              {...field}
              {...inputProps}
              onChange={(e) => {
                field.onChange(e);
                onChange();
              }}
              className="placeholder:text-gray-500 border-gray-200 rounded-lg w-full px-2.5 py-3 border focus:border-brand-hover
            focus-within:border-brand-hover focus:bg-[#eaf1fa]  transition-all focus:ring-0 focus-visible:ring-0 focus-visible:border-brand-hover  outline-none appearance-none disabled:bg-slate-100 pr-8"
            >
              <option value="">
                {t(disabled ? disabledPlaceholder : placeholder || label)}
              </option>
              {options.map((item, idx) => (
                <option value={item?.value} key={idx}>
                  {t(item?.label)}
                </option>
              ))}
            </select>
            <IoIosArrowDown
              className="absolute right-2  top-1/2  -translate-y-1/2"
              size={24}
              color="#57637D"
            />
          </div>
          <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
            {t(error?.message)}
          </p>
        </div>
      )}
    />
  );
}

export default SelectField;
